import styled from '@pinecast/styles';

import type {ElementConfig} from './types';

const TableWrapper = styled('div', {
  width: '100%',
  overflowX: 'auto',
});
const TableInner = styled(
  'table',
  (_, designColors) => ({
    border: 0,
    borderBottom: `1px solid ${designColors.borderGrayNormal}`,
    borderCollapse: 'collapse',
    lineHeight: '1.5',
    marginBottom: 20,
    width: '100%',
  }),
  {className: 'Table'},
);
export const Table = ({
  children,
  ...rest
}: ElementConfig<typeof TableInner>) => {
  return (
    <TableWrapper>
      <TableInner {...rest}>{children}</TableInner>
    </TableWrapper>
  );
};
export const TableHeaderCell = styled('th', (_, designColors) => ({
  borderBottom: `1px solid ${designColors.borderGrayNormal}`,
  color: designColors.headingBlue,
  fontSize: 12,
  lineHeight: 26,
  paddingTop: 0,
  paddingBottom: 0,
  paddingRight: 8,
  paddingLeft: 8,
  textAlign: 'left',
  textTransform: 'uppercase',
  ':first-of-type': {
    paddingLeft: 0,
  },
  ':last-of-type': {
    paddingRight: 0,
  },
}));
export const TableBodyCell = styled(
  'td',
  ({$wrapAt}: {$wrapAt?: number}, designColors) => ({
    borderBottom: `1px solid ${designColors.borderGrayNormal}`,
    fontSize: 14,
    maxWidth: $wrapAt,
    overflow: 'hidden',
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 8,
    paddingLeft: 8,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ':first-of-type': {
      paddingLeft: 0,
    },
    ':last-of-type': {
      paddingRight: 0,
    },
  }),
);
export const TableFooterCell = styled(
  'td',
  ({$wrapAt}: {$wrapAt?: number}) => ({
    fontSize: 14,
    maxWidth: $wrapAt,
    overflow: 'hidden',
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 8,
    paddingLeft: 8,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ':first-of-type': {
      paddingLeft: 0,
    },
    ':last-of-type': {
      paddingRight: 0,
    },
  }),
);
